// Thin localStorage wrapper. One key, JSON blob, no migrations yet.

const KEY = 'velkommen.state.v1';

const defaults = {
  // id → { box: 1..5, due: ISO timestamp, seen: count, correct: count }
  cards: {},
  // Convenience cache of ids that have reached box 5.
  mastered: [],
};

export function loadState() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return structuredClone(defaults);
    return { ...structuredClone(defaults), ...JSON.parse(raw) };
  } catch {
    return structuredClone(defaults);
  }
}

export function saveState(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    // Quota exceeded or private mode — silently no-op rather than crash the UI.
  }
}
